/**
 * 获取根元素的CSS变量值
 *
 * @param {string} variableName - 要获取的CSS变量名
 * @param {string} defaultColor - 如果变量未定义，则返回的默认颜色值，默认为空字符串
 * @returns {string} - 返回CSS变量的值，如果未定义则返回默认颜色
 */
export const getRootColor = (variableName: string, defaultColor: string = '') => {
    if (!variableName) {
        return defaultColor;
    }
    const root = document.documentElement; // 最近的document元素
    const styles = getComputedStyle(root);
    const value = styles.getPropertyValue(variableName);
    return value ? value.trim() : defaultColor;
};
